module.exports = __webpack_public_path__ + "img/no_devices.25e74903.png";